import React from 'react';
export function HeroTestimonials() {
  return <section className="bg-gray-50 py-10 px-6" data-id="element-91">
      <div className="max-w-4xl mx-auto grid md:grid-cols-3 gap-6" data-id="element-92">
        {[{
        initials: 'SF',
        name: 'Sabrina Fernández',
        location: 'Córdoba | Primaria',
        text: 'Armé toda la planificación anual en una sola tarde. Antes me llevaba semanas enteras y nunca quedaba conforme. Esto me devolvió mis fines de semana.'
      }, {
        initials: 'JT',
        name: 'Julieta Torres',
        location: 'Rosario | Secundaria',
        text: 'Mis alumnos de secundaria ahora trabajan sin protestar. Las actividades enganchan desde el primer minuto y se nota que están bien graduadas por nivel.'
      }, {
        initials: 'DM',
        name: 'Diego Martínez',
        location: 'Buenos Aires | Prim. y Sec.',
        text: 'Por primera vez en años entro al aula con todo listo y secuenciado. Se acabaron las clases improvisadas y las búsquedas eternas en Google.'
      }].map(t => <div key={t.name} className="bg-white rounded-2xl shadow p-6" data-id="element-93">
            <div className="flex items-center gap-3 mb-3" data-id="element-94">
              <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-700 font-bold flex items-center justify-center text-sm" data-id="element-95">
                {t.initials}
              </div>
              <div data-id="element-96">
                <div className="flex gap-0.5 text-yellow-400 text-sm mb-0.5" aria-label="5 de 5 estrellas" data-id="element-97">
                  <span data-id="element-98">★</span>
                  <span data-id="element-99">★</span>
                  <span data-id="element-100">★</span>
                  <span data-id="element-101">★</span>
                  <span data-id="element-102">★</span>
                </div>
                <p className="font-semibold text-sm" data-id="element-103">{t.name}</p>
                <p className="text-xs text-gray-400" data-id="element-104">{t.location}</p>
              </div>
            </div>
            <p className="text-gray-700 text-sm italic" data-id="element-105">"{t.text}"</p>
          </div>)}
      </div>
    </section>;
}